const procedureTypes = [
    'query',
    'mutation',
    'subscription'
];

export { procedureTypes };
